import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import Swiper from "swiper";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './digitalizeRetail.less'

let that
export default {
    name: "digitalizeRetail",
    data() {
        return {
			banner: {
				title: '小精灵零售',
				subTitle: '让零售更高效，让生意更轻松！',
				videoAlign: 'right',
				info: '垂直于零售商超业态的线上线下一体化数字经营系统。',
				features: "· 收银&会员一体化<br>· 私域运营自动化<br>· 线上&线下一体化<br>· 供应链&订货一体化",
				tips: '适合：需要数字化建设的零售商家。',
				btnTxt: '',
				btnHref: '',
				btnType: 'href',
				video: 'video/digitalizeRetail.webm',
				bg: "#001472"//#08CA09 "#67C3C4" #F6AE15 #FE4F1C #6F7BD5 
			},
			solution: {
				title: '零售一体化方案',
				subtitle: '为零售商户提供整合的数字解决方案，<br>实现从门店收银、会员管理、外卖管理、供应链管理、财务管理等的全面数字化升级。',
				pic: 'img/digitalizeRetail/solution.png'
			},
			intro: {
				title: '零售版六大核心亮点',
				subTitle: '通过六大产品矩阵能力，<br>全面实现零售的收银数字化 、 会员数字化 、 供应链数字化 、 连锁数字化。',
				pic: 'img/digitalizeRetail/info_banner1.png',
				list: [
					{
						type: 'features',
						title:"01.小精灵收银软件",
						subTitle: "适合中、大型零售商超的数字一体化本地部署收银软件。",
						pic: 'img/digitalizeRetail/info1.png',
						imgAlign: '',
						features:"<span class='bit-blue'>·</span>C/S收银，本地部署，稳定抗压<br><span class='bit-blue'>·</span>收银&会员全面一体化<br><span class='bit-blue'>·</span>线上商城&线下生意一体化<br><span class='bit-blue'>·</span>独立版老板助手APP，移动管店<br>....."
					},
					{
						type: 'features',
						title:"02.小精灵零售SaaS",
						subTitle: "适合中、小型便利超市的数字一体化收银SaaS。",
						pic: 'img/digitalizeRetail/info2.png',
						imgAlign: 'right',
						features:"<span class='bit-blue'>·</span>云端部署，实施便捷<br><span class='bit-blue'>·</span>收银&会员全面一体化<br><span class='bit-blue'>·</span>线上商城&线下生意一体化<br><span class='bit-blue'>·</span>门店订货&总部库存供应链一体化.<br>....."
					},
					{
						type: 'features',
						title:"03.商城小程序",
						subTitle: "自建线上商城/外卖商城，降低平台成本扣点，提升门店收益。",
						pic: 'img/digitalizeRetail/info3.png',
						imgAlign: '',
						features:"<span class='bit-blue'>·</span>  自建商城/外卖小程序，降本增收<br><span class='bit-blue'>·</span>  多店版小程序，支持总部统一管理，门店自主发货<br><span class='bit-blue'>·</span>  会员体系/积分/余额,线上线下⽆缝打通<br><span class='bit-blue'>·</span>  点餐和库存商品同步<br>....."
					},
					{
						type: 'banner',
						pic: 'img/digitalizeRetail/info_banner2.png',
					},
					{
						type: 'list',
						title:"04.私域会员体系",
						subTitle: "全链路会员生命周期运营，全面提升商超运营效率及质量，实现营收增长。",
						pic: '',
						imgAlign: '',
						featureList: [
							{
								title: "1.沉淀会员",
								subTitle: "扫码即会员",
								subTitleColor: "#068CF9",
								pic: 'img/digitalizeRetail/info4.png',
								features: "<span class='bit-blue'>·</span>3秒开卡 <br><span class='bit-blue'>·</span>电子海报 <br><span class='bit-blue'>·</span>公众号联动<br><span class='bit-blue'>·</span>自动积分<br><span class='bit-blue'>·</span>会员自动标签<br><span class='bit-blue'>·</span>社交裂变邀请"
							},
							{
								title: "2.提升活跃",
								subTitle: "成长与惊喜",
								subTitleColor: "#068CF9",
								imgAlign:'right',
								pic: 'img/digitalizeRetail/info5.png',
								features: "<span class='bit-blue'>·</span>会员等级与折扣<br><span class='bit-blue'>·</span>会员自动升级/自动优惠<br><span class='bit-blue'>·</span>活动自动触达 <br><span class='bit-blue'>·</span>积分商城<br><span class='bit-blue'>·</span>定时营销 <br><span class='bit-blue'>·</span>生日惊喜"
							},
							{
								title: "3.提高复购",
								subTitle: "价值感与忠诚度",
								subTitleColor: "#068CF9",
								pic: 'img/digitalizeRetail/info6.png',
								features: "<span class='bit-blue'>·</span>会员储值<br><span class='bit-blue'>·</span>自动组合支付<br><span class='bit-blue'>·</span>场景化推送<br><span class='bit-blue'>·</span>会员社群<br><span class='bit-blue'>·</span>智能分组<br><span class='bit-blue'>·</span>精准发券"
							},
							{
								title: "4.裂变传播",
								subTitle: "场景化裂变",
								subTitleColor: "#068CF9",
								imgAlign:'right',
								pic: 'img/digitalizeRetail/info7.png',
								features: "<span class='bit-blue'>·</span>新人邀请有礼<br><span class='bit-blue'>·</span>互动营销抽奖<br><span class='bit-blue'>·</span>红包裂变<br><span class='bit-blue'>·</span>朋友圈裂变<br><span class='bit-blue'>·</span>社群邀约<br><span class='bit-blue'>·</span>权益会员"
							},
							{
								title: "5.变现增收",
								subTitle: "场景化消费",
								subTitleColor: "#068CF9",
								pic: 'img/digitalizeRetail/info8.png',
								features: "<span class='bit-blue'>·</span>自营外卖<br><span class='bit-blue'>·</span>自营商城<br><span class='bit-blue'>·</span>积分商城<br><span class='bit-blue'>·</span>直播卖货<br>......"
							}
						]
					},
					{
						type: 'banner',
						pic: 'img/digitalizeRetail/info_banner3.png',
					},
					{
						type: 'features',
						title:"05.供应链体系",
						subTitle: "连锁加盟供应链系统，实现门店订货、总部供货、物流配送、商品库存管理的闭环。",
						pic: 'img/digitalizeRetail/info9.png',
						imgAlign: '',
						features:"<span class='bit-blue'>·</span>支持全国性多配送中心的配送方式<br><span class='bit-blue'>·</span>支持自配集采集配模式<br><span class='bit-blue'>·</span>支持终端多种促销订货方案<br><span class='bit-blue'>·</span>支持多种配送规则<br><span class='bit-blue'>·</span>支持第三方物流信息配送模式"
					},
					{
						type: 'icon-list',
						title:"06.全场景收银端能力",
						subTitle: "提供全系列零售收银端能力，<br>无论商户想要使用原来的软硬件或者更换新的软硬件，都有合适的产品能力。",
						pic: '',
						imgAlign: '',
						featureStyle: "row",
						featureList: [
							{
								title: "收银插件",
								subTitle: "适配市面上99%收银系统",
								pic: 'img/digitalizeRetail/shouyin.png',
							},
							{
								title: "4G语音王码牌",
								subTitle: "支付+优惠同时播报，刺激消费",
								pic: 'img/digitalizeRetail/4g.png',
							},
							{
								title: "手持收款设备",
								subTitle: "收银、核销、出票、播报一体化",
								pic: 'img/digitalizeRetail/pos.png',
							},
							{
								title: "商户通APP",
								subTitle: "移动客户端，收款、管店于一体",
								pic: 'img/digitalizeRetail/app.png',
							},
						]
					},
				]
			},
            sta: {
				title:"零售收银安全稳定",
				list: [
					{
						num: "20万+",
						info: "零售商户"
					},
					{
						num: "5亿+",
						info: "消费者"
					},
					{
						num: "4000万+",
						info: "商户会员"
					},
					{
						num: "280万+",
						info: "商品"
					}
				]
			},
            rollList: [
                {
                    src: "/img/digitalizeRetail/roll1.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeRetail/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeRetail/roll3.png",
                    size: 1,
                },
                {
                    src: "/img/digitalizeRetail/roll4.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeRetail/roll5.png",
                    size: 2,
                }
            ],
        }
    },
    components: {
        skeleton,
        pay,
        QRCode,
        vueSeamlessScroll
    },
	mounted(){
		that = this
		this.$nextTick( () => {
			that.swiper = new Swiper ('.swiper-pc', {
				// 如果需要滚动条
				// scrollbar: '.swiper-scrollbar',
				//如果需要自动切换海报
				// autoplay: {
				// 	delay: 3000,//时间 毫秒
				// 	disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
				// },
				slidesPerView: 'auto',
				spaceBetween: 0,
				centeredSlides: false,
				// pagination: {
				// 	el: '.swiper-pagination',
				// 	clickable: true
				// }
			})
		})
	},
    methods: {
		changeSwiper(index){
			console.log('changeSwiper',index)
			this.swiper.slideTo(index)
			this.versions.currentTab = index
		}
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
